import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="136"
      height="48"
      viewBox="0 0 352 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9157 128C13.5308 128 16.1458 128 18.7608 128C123.587 128 228.413 128 333.239 128C335.854 128 338.469 128 341.084 128C342.589 128 344.094 128 345.598 128C346.103 128.001 346.59 127.944 347.081 127.827C347.316 127.77 347.548 127.7 347.776 127.618C348.696 127.284 349.448 126.806 350.139 126.11C350.236 126.013 350.329 125.912 350.419 125.809C350.534 125.678 350.643 125.542 350.746 125.402C350.753 125.392 350.761 125.382 350.768 125.372C351.015 125.033 351.225 124.679 351.401 124.299C351.409 124.283 351.416 124.266 351.424 124.249C351.432 124.232 351.439 124.215 351.447 124.198C351.455 124.182 351.462 124.164 351.469 124.147C351.491 124.096 351.513 124.044 351.534 123.993C351.538 123.981 351.544 123.968 351.549 123.956C351.645 123.712 351.725 123.465 351.792 123.212C351.794 123.203 351.796 123.195 351.799 123.186C351.932 122.662 351.998 122.141 351.998 121.6C351.998 117.333 351.998 113.067 351.998 108.799C351.998 74.6665 351.998 40.5336 351.998 6.40019C351.998 2.86566 349.133 0 345.598 0C344.094 0 342.589 0 341.084 0C339.869 0 338.654 0 337.439 0C337.405 0 337.372 0 337.337 0C337.287 0 337.238 0 337.188 0C335.871 0 334.554 0 333.238 0C228.412 0 123.585 0 18.7603 0C17.4435 0 16.1272 0 14.8109 0C14.7613 0 14.711 0 14.6613 0C14.6275 0 14.5936 0 14.5592 0C13.3445 0 12.1292 0 10.9146 0C9.40975 0 7.90499 0 6.40019 0C2.86566 0 0 2.86566 0 6.40019C0 40.5336 0 74.6665 0 108.799C0 113.067 0 117.333 0 121.6C0 125.134 2.86566 128 6.40019 128C7.90612 128 9.41092 128 10.9157 128Z"
        fill="#E3E3E3"
      />
      <path
        d="M0.0012207 108.4C0.0012207 108.533 0.0012207 108.666 0.0012207 108.799C0.0012207 113.067 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.86631 127.999 6.40196 127.999C7.90676 127.999 9.41159 127.999 10.9164 127.999C13.5314 127.999 16.1465 127.999 18.761 127.999C48.9213 127.999 191.08 127.999 221.24 127.999C223.856 127.999 338.47 127.999 341.085 127.999C342.59 127.999 344.095 127.999 345.6 127.999C346.104 128.001 346.591 127.943 347.081 127.826C347.318 127.77 347.549 127.7 347.777 127.618C348.697 127.284 349.45 126.805 350.139 126.11C350.236 126.013 350.33 125.912 350.42 125.809C350.849 125.318 351.185 124.793 351.448 124.198C351.456 124.182 351.463 124.164 351.471 124.147C351.602 123.842 351.709 123.532 351.793 123.211C351.795 123.202 351.797 123.194 351.799 123.185C351.934 122.661 351.999 122.14 351.999 121.599C351.999 117.332 351.999 113.066 351.999 108.799C351.999 108.666 351.999 108.532 351.999 108.399H0.0012207V108.4Z"
        fill="url(#paint0_linear_6091_22496)"
      />
      <path
        opacity="0.2"
        d="M19.6007 0C19.3207 0 19.0408 0 18.7608 0C17.4445 0 16.1277 0 14.8114 0C14.7618 0 14.7115 0 14.6618 0C14.628 0 14.5941 0 14.5602 0C13.345 0 12.1298 0 10.9151 0C9.41031 0 7.90548 0 6.40068 0C2.86559 0 0.000488281 2.86566 0.000488281 6.40019C0.000488281 40.5336 0.000488281 74.666 0.000488281 108.799C0.000488281 113.067 0.000488281 117.333 0.000488281 121.6C0.000488281 125.134 2.86559 127.999 6.40068 127.999C7.90548 127.999 9.41031 127.999 10.9151 127.999C13.5302 127.999 16.1457 127.999 18.7602 127.999C19.0402 127.999 19.3202 127.999 19.6001 127.999V0H19.6007Z"
        fill="url(#paint1_linear_6091_22496)"
      />
      <path
        opacity="0.2"
        d="M332.399 0C332.679 0 332.959 0 333.239 0C334.556 0 335.872 0 337.189 0C337.238 0 337.288 0 337.338 0C337.372 0 337.406 0 337.44 0C338.655 0 339.87 0 341.085 0C342.59 0 344.095 0 345.599 0C349.134 0 351.999 2.86566 351.999 6.40019C351.999 40.5336 351.999 74.666 351.999 108.799C351.999 113.067 351.999 117.333 351.999 121.6C351.999 125.134 349.134 127.999 345.599 127.999C344.095 127.999 342.59 127.999 341.085 127.999C338.47 127.999 335.854 127.999 333.239 127.999C332.959 127.999 332.68 127.999 332.4 127.999V0H332.399Z"
        fill="url(#paint2_linear_6091_22496)"
      />
      <path
        d="M243.855 19.6002C243.675 19.6002 243.6 19.6753 243.6 19.8565C243.6 49.2859 243.6 78.7153 243.6 108.145C243.6 108.325 243.675 108.4 243.855 108.4C273.285 108.4 302.714 108.4 332.143 108.4C332.324 108.4 332.399 108.325 332.399 108.145C332.399 78.7153 332.399 49.2859 332.399 19.8565C332.399 19.6753 332.324 19.6002 332.143 19.6002C302.714 19.6002 273.285 19.6002 243.855 19.6002Z"
        fill="#575756"
      />
      <path
        d="M331.999 107.744C331.999 107.925 331.924 108 331.743 108C302.58 108 273.418 108 244.255 108C244.075 108 244 107.925 244 107.744C244 78.5815 244 49.4185 244 20.2561C244 20.0754 244.075 20.0004 244.255 20.0004C273.418 20.0004 302.58 20.0004 331.743 20.0004C331.924 20.0004 331.999 20.0754 331.999 20.2561C331.999 49.4185 331.999 78.5815 331.999 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M322.003 97.8538C322.003 97.5129 321.867 97.3667 321.523 97.3667C320.524 97.3667 319.526 97.3667 318.527 97.3667C318.527 97.0935 318.527 96.8197 318.527 96.5465C318.527 95.951 318.227 95.5457 317.95 95.0835C317.006 93.5104 316.832 91.6889 318.788 90.8524C320.462 90.135 322.325 91.3695 322.327 93.1898C322.327 93.3439 322.311 93.494 322.279 93.6453C322.208 93.9777 322.319 94.1426 322.65 94.2143C322.983 94.2871 323.15 94.1781 323.218 93.844C323.807 91.0703 320.897 88.8368 318.338 90.0018C317.15 90.542 316.356 91.7008 316.287 93.0057C316.252 93.6836 316.418 94.2537 316.715 94.8481C316.925 95.268 317.567 95.9832 317.567 96.5471C317.567 97.2882 317.567 98.0299 317.567 98.7716C317.567 99.1113 317.708 99.2513 318.048 99.2513C318.222 99.2513 318.396 99.2513 318.57 99.2513C318.57 99.3998 318.57 99.5476 318.57 99.6955C318.57 100.035 318.711 100.175 319.051 100.175C319.541 100.175 320.031 100.175 320.521 100.175C320.86 100.175 321.001 100.035 321.001 99.6955C321.001 99.5476 321.001 99.3998 321.001 99.2513C321.175 99.2513 321.349 99.2513 321.524 99.2513C321.863 99.2513 322.004 99.1113 322.004 98.7716C322.003 98.4651 322.003 98.1591 322.003 97.8538Z"
        fill="#575756"
      />
      <path
        d="M287.436 28.6402C287.436 52.2136 287.436 75.7869 287.436 99.3602C287.436 99.7581 287.601 99.9235 287.999 99.9235C288.398 99.9235 288.562 99.7581 288.562 99.3602C288.562 75.7869 288.562 52.2136 288.562 28.6402C288.562 28.2417 288.398 28.0769 287.999 28.0769C287.601 28.0769 287.436 28.2417 287.436 28.6402Z"
        fill="#B2B2B2"
      />
      <path
        d="M258.353 97.8538C258.353 97.5129 258.217 97.3667 257.873 97.3667C256.874 97.3667 255.876 97.3667 254.877 97.3667C254.877 97.0935 254.877 96.8197 254.877 96.5465C254.877 95.951 254.576 95.5457 254.3 95.084C253.356 93.5104 253.182 91.6895 255.138 90.8524C256.812 90.135 258.674 91.37 258.677 93.1903C258.677 93.3439 258.661 93.494 258.629 93.6453C258.558 93.9777 258.669 94.1426 258.999 94.2143C259.332 94.2871 259.5 94.1781 259.568 93.844C260.157 91.0703 257.247 88.8368 254.688 90.0018C253.5 90.542 252.705 91.7008 252.637 93.0057C252.602 93.6836 252.768 94.2537 253.065 94.8481C253.275 95.268 253.917 95.9832 253.917 96.5471C253.917 97.2882 253.917 98.0299 253.917 98.7716C253.917 99.1113 254.058 99.2519 254.398 99.2519C254.572 99.2519 254.746 99.2519 254.92 99.2519C254.92 99.3998 254.92 99.5476 254.92 99.6955C254.92 100.035 255.061 100.176 255.401 100.176C255.891 100.176 256.38 100.176 256.87 100.176C257.21 100.176 257.351 100.035 257.351 99.6955C257.351 99.5476 257.351 99.3998 257.351 99.2519C257.525 99.2519 257.699 99.2519 257.873 99.2519C258.213 99.2519 258.354 99.1113 258.354 98.7716C258.353 98.4651 258.353 98.1591 258.353 97.8538Z"
        fill="#575756"
      />
      <path
        d="M19.8565 19.5997C19.6759 19.5997 19.6008 19.6747 19.6008 19.8565C19.6008 49.2859 19.6008 78.7147 19.6008 108.144C19.6008 108.325 19.6759 108.4 19.8565 108.4C49.2859 108.4 78.7148 108.4 108.144 108.4C108.326 108.4 108.4 108.325 108.4 108.144C108.4 78.7147 108.4 49.2859 108.4 19.8565C108.4 19.6747 108.326 19.5997 108.144 19.5997C78.7148 19.5997 49.2859 19.5997 19.8565 19.5997Z"
        fill="#575756"
      />
      <path
        d="M107.745 20.2555V19.9998H20.2573"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.745 19.9998C107.925 19.9998 108 20.0749 108 20.2555C108 49.4191 108 78.5809 108 107.744C108 107.925 107.925 108 107.745 108C78.5815 108 49.4191 108 20.2567 108C20.076 108 20.001 107.925 20.001 107.744C20.001 78.5815 20.001 49.4191 20.001 20.2555C20.001 20.0749 20.076 19.9998 20.2567 19.9998"
        fill="#E3E3E3"
      />
      <path
        d="M64.0006 94.8792C81.0548 94.8792 94.88 81.054 94.88 63.9998C94.88 46.9455 81.0548 33.1203 64.0006 33.1203C46.9463 33.1203 33.1211 46.9455 33.1211 63.9998C33.1211 81.054 46.9463 94.8792 64.0006 94.8792Z"
        fill="url(#paint3_linear_6091_22496)"
      />
      <path
        d="M48.6409 68.5599C51.1594 68.5599 53.201 66.5182 53.201 63.9997C53.201 61.4813 51.1594 59.4396 48.6409 59.4396C46.1224 59.4396 44.0808 61.4813 44.0808 63.9997C44.0808 66.5182 46.1224 68.5599 48.6409 68.5599Z"
        fill="#3C3C3B"
      />
      <path
        d="M79.3606 68.5599C81.8791 68.5599 83.9208 66.5182 83.9208 63.9997C83.9208 61.4813 81.8791 59.4396 79.3606 59.4396C76.8422 59.4396 74.8005 61.4813 74.8005 63.9997C74.8005 66.5182 76.8422 68.5599 79.3606 68.5599Z"
        fill="#3C3C3B"
      />
      <path
        d="M96.6691 98.0225C96.2571 98.4357 96.2571 99.1051 96.6691 99.5183C97.0834 99.9326 97.7506 99.9298 98.1638 99.5171C98.5775 99.1051 98.578 98.4357 98.1649 98.0225C97.7522 97.6105 97.0823 97.6105 96.6691 98.0225Z"
        fill="#575756"
      />
      <path
        d="M93.6539 98.2906C92.9218 98.2906 92.1898 98.2906 91.4577 98.2906C91.3284 98.2906 91.2759 98.2375 91.2759 98.1088C91.2759 96.3438 91.2759 94.5788 91.2759 92.8138C91.2759 92.6846 91.329 92.6321 91.4577 92.6321C93.2227 92.6321 94.9877 92.6321 96.7527 92.6321C96.8814 92.6321 96.9339 92.6851 96.9345 92.8138C96.9345 93.5459 96.9345 94.278 96.9345 95.0112C96.9345 95.351 97.0744 95.491 97.4142 95.491C97.754 95.491 97.8952 95.351 97.8952 95.0112C97.8952 94.278 97.8952 93.5459 97.8952 92.8138C97.894 92.1834 97.3832 91.6731 96.7533 91.672C94.9882 91.672 93.2232 91.672 91.4582 91.672C90.8278 91.672 90.3164 92.1834 90.3164 92.8138C90.3164 94.5788 90.3164 96.3438 90.3164 98.1088C90.3164 98.7393 90.8278 99.2508 91.4582 99.2508C92.1903 99.2508 92.9224 99.2508 93.6545 99.2508C93.9931 99.2508 94.1342 99.1108 94.1342 98.771C94.1342 98.4312 93.9926 98.2906 93.6539 98.2906Z"
        fill="#575756"
      />
      <path
        d="M67.1205 41.5998V33.2873C66.0887 33.1823 65.0484 33.1197 64.0003 33.1197C62.9476 33.1197 61.9068 33.1739 60.8806 33.276V41.5993H67.1205V41.5998Z"
        fill="#3C3C3B"
      />
      <path
        d="M37.6003 59.3104C37.6003 55.5314 37.6003 51.7519 37.6003 47.973C35.4548 51.4996 34.0042 55.4925 33.4177 59.7602C34.6618 59.7602 35.9058 59.7602 37.1504 59.7602C37.4682 59.7602 37.6003 59.6287 37.6003 59.3104Z"
        fill="#D0D0D0"
      />
      <path
        d="M90.8937 59.7602C92.1248 59.7602 93.3564 59.7602 94.588 59.7602C94.5801 59.7071 94.5728 59.6535 94.5649 59.6004C94.557 59.5473 94.5496 59.4938 94.5417 59.4407C93.9524 55.493 92.7214 51.9749 90.7204 48.521C90.6188 48.3466 90.5042 48.1801 90.4004 48.0085C90.4004 51.7609 90.4004 55.515 90.4004 59.2674C90.4004 59.6157 90.5449 59.7602 90.8937 59.7602Z"
        fill="#D0D0D0"
      />
      <path
        d="M60.8806 86.3995V94.7228C61.9068 94.8256 62.9476 94.8792 64.0003 94.8792C65.0535 94.8792 66.0943 94.825 67.1205 94.7228V86.3995H60.8806Z"
        fill="#3C3C3B"
      />
      <path
        d="M37.0742 68.2398C35.8556 68.2398 34.6369 68.2398 33.4177 68.2398C34.0042 72.5081 35.4548 76.4998 37.6003 80.0264C37.6003 76.2729 37.6003 72.52 37.6003 68.7664C37.6003 68.3939 37.4462 68.2398 37.0742 68.2398Z"
        fill="#D0D0D0"
      />
      <path
        d="M91.0122 68.2398C90.5793 68.2398 90.4004 68.4193 90.4004 68.8506C90.4004 72.5764 90.4004 76.3017 90.4004 80.0264C92.5458 76.4998 93.9965 72.5081 94.5829 68.2398C93.3931 68.2398 92.2026 68.2398 91.0122 68.2398Z"
        fill="#D0D0D0"
      />
      <path
        d="M62.1038 94.8092C62.7337 94.8498 63.3653 94.8798 64.0009 94.8798C64.6387 94.8798 65.2692 94.8532 65.8974 94.8148V85.2713H62.1033V94.8092H62.1038Z"
        fill="url(#paint4_linear_6091_22496)"
      />
      <path
        d="M65.8973 33.1902C65.2674 33.1496 64.6358 33.1197 64.0003 33.1197C63.3625 33.1197 62.732 33.1462 62.1038 33.1846V42.7281H65.8979V33.1902H65.8973Z"
        fill="url(#paint5_linear_6091_22496)"
      />
      <path
        d="M132.256 19.4653C132.075 19.4653 132 19.5403 132 19.7209C132 49.1503 132 78.5791 132 108.009C132 108.19 132.075 108.265 132.256 108.265C161.685 108.265 191.114 108.265 220.543 108.265C220.724 108.265 220.799 108.19 220.799 108.009C220.799 78.5791 220.799 49.1503 220.799 19.7209C220.799 19.5403 220.724 19.4653 220.543 19.4653C191.114 19.4653 161.685 19.4653 132.256 19.4653Z"
        fill="#575756"
      />
      <path
        d="M220.4 107.608C220.4 107.79 220.325 107.865 220.143 107.865C190.981 107.865 161.818 107.865 132.656 107.865C132.475 107.865 132.4 107.79 132.4 107.608C132.4 78.446 132.4 49.2835 132.4 20.1211C132.4 19.9405 132.475 19.8655 132.656 19.8655C161.818 19.8655 190.981 19.8655 220.143 19.8655C220.325 19.8655 220.4 19.9405 220.4 20.1211C220.4 49.2835 220.4 78.446 220.4 107.608Z"
        fill="#E3E3E3"
      />
      <path
        d="M207.338 98.1562C205.879 98.1562 204.421 98.1562 202.962 98.1562C203.052 97.292 203.143 96.428 203.234 95.5644C203.429 93.7023 206.137 93.5341 206.504 95.3764C206.589 95.7879 207.124 95.9042 207.367 95.5599C207.442 95.4537 207.467 95.3544 207.452 95.2251C207.419 94.9621 207.326 94.734 207.208 94.5037C206.818 93.744 206.313 93.3799 205.489 93.1925C203.907 92.833 202.45 93.8393 202.279 95.4638C202.17 96.5046 202.059 97.5455 201.95 98.5857C201.912 98.9526 202.058 99.1159 202.428 99.1159C202.933 99.1159 203.436 99.1159 203.94 99.1159C203.988 100.37 205.778 100.37 205.824 99.1159C206.33 99.1159 206.833 99.1159 207.337 99.1159C207.677 99.1159 207.818 98.9753 207.818 98.6355C207.818 98.2957 207.677 98.1562 207.338 98.1562Z"
        fill="#575756"
      />
      <path
        d="M209.15 89.2572C208.866 89.0721 208.671 89.1122 208.486 89.3967C208.3 89.6806 208.341 89.8753 208.625 90.061C210.297 91.1527 211.135 92.4248 211.526 94.3755C211.592 94.708 211.757 94.8186 212.09 94.752C212.423 94.6848 212.533 94.5195 212.467 94.187C212.061 92.1556 210.891 90.3929 209.15 89.2572Z"
        fill="#575756"
      />
      <path
        d="M197.3 94.187C197.233 94.5195 197.344 94.6854 197.676 94.752C198.009 94.8186 198.174 94.7085 198.241 94.3755C198.63 92.4248 199.47 91.1521 201.141 90.061C201.425 89.8753 201.466 89.6806 201.281 89.3967C201.095 89.1122 200.901 89.0715 200.616 89.2572C198.875 90.3929 197.705 92.1556 197.3 94.187Z"
        fill="#575756"
      />
      <path
        d="M199.844 94.5309C199.767 94.8617 199.875 95.0276 200.204 95.1066C200.535 95.1857 200.703 95.0779 200.779 94.7471C201.054 93.5663 201.581 92.7964 202.619 92.1557C202.907 91.9774 202.952 91.7831 202.773 91.4947C202.595 91.2051 202.402 91.16 202.113 91.3401C200.832 92.128 200.18 93.0746 199.844 94.5309Z"
        fill="#575756"
      />
      <path
        d="M207.654 91.3401C207.365 91.1606 207.171 91.2063 206.992 91.4941C206.814 91.7831 206.859 91.9762 207.147 92.1557C208.186 92.7964 208.715 93.5634 208.986 94.7464C209.062 95.0772 209.231 95.1817 209.562 95.1072C209.894 95.0316 209.998 94.8622 209.923 94.5315C209.587 93.0729 208.93 92.1303 207.654 91.3401Z"
        fill="#575756"
      />
      <path
        d="M158.946 62.138C156.619 62.1386 156.582 65.5772 158.908 65.6291C161.234 65.681 161.274 62.1386 158.946 62.138Z"
        fill="#3C3C3B"
      />
      <path
        d="M176.4 79.5742C174.073 79.5742 174.035 83.0134 176.362 83.0648C178.688 83.1161 178.727 79.5742 176.4 79.5742Z"
        fill="#3C3C3B"
      />
      <path
        d="M171.964 56.9023C171.964 54.5751 171.964 52.248 171.964 49.9208C171.964 48.9562 171.182 48.175 170.219 48.175C169.254 48.175 168.472 48.9562 168.472 49.9208C168.472 52.248 168.472 54.5751 168.472 56.9023C168.472 57.8658 169.254 58.6476 170.219 58.6476C171.182 58.6476 171.964 57.8658 171.964 56.9023Z"
        fill="#3C3C3B"
      />
      <path
        d="M190.508 74.3379C190.508 72.0107 190.508 69.6836 190.508 67.3564C190.508 66.3923 189.726 65.6105 188.762 65.6105C187.798 65.6105 187.016 66.3923 187.016 67.3564C187.016 69.6836 187.016 72.0107 187.016 74.3379C187.016 75.3019 187.798 76.0837 188.762 76.0837C189.727 76.0831 190.508 75.3019 190.508 74.3379Z"
        fill="#3C3C3B"
      />
      <path
        d="M165.783 74.3379C165.783 72.0107 165.783 69.6836 165.783 67.3564C165.783 66.3923 165.001 65.6105 164.038 65.6105C163.073 65.6105 162.292 66.3923 162.292 67.3564C162.292 69.6836 162.292 72.0107 162.292 74.3379C162.292 75.3019 163.073 76.0837 164.038 76.0837C165.001 76.0831 165.783 75.3019 165.783 74.3379Z"
        fill="#3C3C3B"
      />
      <path
        d="M184.327 56.9023C184.327 54.5751 184.327 52.248 184.327 49.9208C184.327 48.9562 183.545 48.175 182.581 48.175C181.617 48.175 180.835 48.9562 180.835 49.9208C180.835 52.248 180.835 54.5751 180.835 56.9023C180.835 57.8658 181.617 58.6476 182.581 58.6476C183.545 58.6476 184.327 57.8658 184.327 56.9023Z"
        fill="#3C3C3B"
      />
      <path
        d="M187.017 53.3921C187.017 55.7193 187.017 58.0464 187.017 60.3736C187.017 61.3382 187.798 62.1194 188.763 62.1194C189.726 62.1194 190.508 61.3382 190.508 60.3736C190.508 58.0464 190.508 55.7193 190.508 53.3921C190.508 52.4286 189.726 51.6468 188.763 51.6468C187.798 51.6468 187.017 52.4286 187.017 53.3921Z"
        fill="#3C3C3B"
      />
      <path
        d="M180.835 70.8655C180.835 73.1927 180.835 75.5198 180.835 77.847C180.835 78.8111 181.617 79.5929 182.582 79.5929C183.545 79.5929 184.327 78.8111 184.327 77.847C184.327 75.5198 184.327 73.1927 184.327 70.8655C184.327 69.9014 183.545 69.1202 182.582 69.1202C181.617 69.1208 180.835 69.9014 180.835 70.8655Z"
        fill="#3C3C3B"
      />
      <path
        d="M178.145 74.3379C178.145 72.0107 178.145 69.6836 178.145 67.3564C178.145 66.3923 177.363 65.6105 176.4 65.6105C175.435 65.6105 174.654 66.3923 174.654 67.3564C174.654 69.6836 174.654 72.0107 174.654 74.3379C174.654 75.3019 175.435 76.0837 176.4 76.0837C177.363 76.0831 178.145 75.3019 178.145 74.3379Z"
        fill="#3C3C3B"
      />
      <path
        d="M178.145 60.3736C178.145 58.0464 178.145 55.7193 178.145 53.3921C178.145 52.4286 177.363 51.6468 176.4 51.6468C175.435 51.6468 174.654 52.4286 174.654 53.3921C174.654 55.7193 174.654 58.0464 174.654 60.3736C174.654 61.3382 175.435 62.1194 176.4 62.1194C177.363 62.1194 178.145 61.3382 178.145 60.3736Z"
        fill="#3C3C3B"
      />
      <path
        d="M171.964 77.847C171.964 75.5198 171.964 73.1927 171.964 70.8655C171.964 69.9014 171.182 69.1202 170.219 69.1202C169.254 69.1202 168.472 69.9014 168.472 70.8655C168.472 73.1927 168.472 75.5198 168.472 77.847C168.472 78.8111 169.254 79.5929 170.219 79.5929C171.182 79.5929 171.964 78.8111 171.964 77.847Z"
        fill="#3C3C3B"
      />
      <path
        d="M165.783 60.3736C165.783 58.0464 165.783 55.7193 165.783 53.3921C165.783 52.4286 165.001 51.6468 164.038 51.6468C163.073 51.6468 162.292 52.4286 162.292 53.3921C162.292 55.7193 162.292 58.0464 162.292 60.3736C162.292 61.3382 163.073 62.1194 164.038 62.1194C165.001 62.1194 165.783 61.3382 165.783 60.3736Z"
        fill="#3C3C3B"
      />
      <path
        d="M193.852 62.1409C191.526 62.1409 191.488 65.58 193.814 65.632C196.141 65.6833 196.18 62.1409 193.852 62.1409Z"
        fill="#3C3C3B"
      />
      <path
        d="M170.219 62.138C167.892 62.1386 167.853 65.5772 170.18 65.6291C172.506 65.681 172.546 62.1386 170.219 62.138Z"
        fill="#3C3C3B"
      />
      <path
        d="M182.581 62.138C180.254 62.1386 180.216 65.5772 182.543 65.6291C184.869 65.681 184.908 62.1386 182.581 62.138Z"
        fill="#3C3C3B"
      />
      <path
        d="M176.4 44.6653C174.073 44.6653 174.035 48.1038 176.362 48.1557C178.688 48.2076 178.727 44.6653 176.4 44.6653Z"
        fill="#3C3C3B"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6091_22496"
          x1="176"
          y1="109.076"
          x2="176"
          y2="127.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.2624" stopColor="#E5E5E5" stopOpacity="0.5" />
          <stop offset="0.5198" stopColor="#EBEBEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6091_22496"
          x1="16.5595"
          y1="63.9993"
          x2="0.308842"
          y2="63.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6091_22496"
          x1="335.441"
          y1="63.9996"
          x2="351.691"
          y2="63.9996"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6091_22496"
          x1="64.0007"
          y1="94.8797"
          x2="64.0007"
          y2="33.1196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6091_22496"
          x1="64.0006"
          y1="94.7473"
          x2="64.0006"
          y2="85.2422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6091_22496"
          x1="64.0005"
          y1="33.2522"
          x2="64.0005"
          y2="42.7572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
